export interface NbaSuggestion {
  action: NbaActions;
  upliftPercent: number;
  suggestedAt?: string;
  appliedAt?: string;
}

export enum NbaActions {
  ADD_ADDRESS = 'ADD_ADDRESS',
  ADD_DATE_FROM = 'ADD_DATE_FROM',
  ADD_DOCUMENT = 'ADD_DOCUMENT',
  ADD_IMAGE = 'ADD_IMAGE',
  ADD_LISTER_PHONE = 'ADD_LISTER_PHONE',
  BOOK_PREMIUM_LISTING = 'BOOK_PREMIUM_LISTING',
  BOOK_REGIONAL_HIGHLIGHT = 'BOOK_REGIONAL_HIGHLIGHT',
  BOOK_TOP_LISTING = 'BOOK_TOP_LISTING',
  CHECK_PRICE_IAZI = 'CHECK_PRICE_IAZI',
  IMPROVE_DESCRIPTION = 'IMPROVE_DESCRIPTION',
  IMPROVE_TITLE = 'IMPROVE_TITLE',
}
